import React, { Fragment, useState, useEffect, useRef } from "react";
import Topbar from "../layouts/TopBar";
import Footer from "../layouts/Footer";
import UserResources from "../resources/UserResources";
import { toast } from "react-toastify";
import moment from "moment/moment";
import { connect } from "react-redux";


function About({isLoggedIn, loggedInUser}){
    const ulStyles = {
        opacity: '1000 !important', // Set the desired opacity value
    }
    
    const [users, setUsers] = useState([])
    const [activeUsers, setActiveUsers] = useState([])

    const loadUsers = () => {
        let resources = new UserResources()
        return resources.get_non()
    }


    useEffect(() => {
        loadUsers().then(response => {
            setUsers(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });
    }, []);

    return(
        <Fragment>
            <Topbar/>  
            <div className="hero-area">
            <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                            <h1 style={{color:"#ffa800"}} className="block-title"><strong>About Us</strong></h1>
                        </div>
                    </div>
                </div>
            </div>
        {/* <!-- Main Content --> */}
        <div id="main-container">
    	<div className="content">
        	<div className="container">
            	<h2>OUR PASTORS</h2>
               	<p style={{color:"#ffa800"}} className="accent-color lead"><strong>Meet the Lead Pastors of the The Liberty Church London and Pastor in charge of the Production team.</strong></p>
                <div className="spacer-20"></div>
                <div className="row">
                	<div className="col-md-4 col-sm-4">
                    	<div className="grid-item grid-staff-item">
                            <div className="grid-item-inner">
                              	<div style = {{position:"relative", width:"100%", paddingTop: "150%", overflow: "hidden"}}><img src="https://ik.imagekit.io/seyi/Tlc_Media/Member_Pictures/psfa.jpg?updatedAt=1759581994107" alt="" style={{width: "100%", height:"100%", objectFit: "cover", position:"absolute", top:"0", left:"0"}}/></div>
                              	<div className="grid-item-content">
                                	<h3 style={{color:"#003165"}}>Pastor Sola Fola-Alade</h3>
                                    <span className="meta-data">Lead/Visionary Pastor</span>
                                	<ul className="social-icons-rounded social-icons-colored">
                                    	<li className="facebook"><a href="https://www.facebook.com/people/DrSola-Fola-Alade/100063780881442/" target="_blank"><i className="fa fa-facebook"></i></a></li>
                                        <li className="instagram"><a href="https://www.instagram.com/dr.solafolaalade/?hl=en" target="_blank"><i className="fa fa-instagram"></i></a></li>
                                  	</ul>
                                	<p>The Visionary pastor of the Liberty Church.</p>
                              	</div>
                            </div>
                       	</div>
                    </div>
                	<div className="col-md-4 col-sm-4">
                    	<div className="grid-item grid-staff-item">
                            <div className="grid-item-inner">
                              	<div style = {{position:"relative", width:"100%", paddingTop: "150%", overflow: "hidden"}}><img src="https://ik.imagekit.io/seyi/Tlc_Media/Member_Pictures/pbfa.jpg" alt="" style={{width: "100%", height:"100%", objectFit: "cover", position:"absolute", top:"0", left:"0"}}/></div>
                              	<div className="grid-item-content">
                                	<h3 style={{color:"#003165"}}>Pastor Bimbo Fola Alade</h3>
                                    <span className="meta-data">Lead Pastor</span>
                                	<ul className="social-icons-rounded social-icons-colored">
                                        <li className="facebook"><a href="https://www.facebook.com/pastor.folaalade/" target="_blank"><i className="fa fa-facebook"></i></a></li>
                                        <li className="instagram"><a href="https://www.instagram.com/bimbo_folaalade/?hl=en" target="_blank"><i className="fa fa-instagram"></i></a></li>
                                  	</ul>
                                	<p>Resident Pastor and wife to PSFA. 
                                    </p>
                              	</div>
                            </div>
                       	</div>
                    </div>
                	<div className="col-md-4 col-sm-4">
                    	<div className="grid-item grid-staff-item">
                            <div className="grid-item-inner">
                              	<div style = {{position:"relative", width:"100%", paddingTop: "150%", overflow: "hidden"}}><img src="https://ik.imagekit.io/seyi/Tlc_Media/Member_Pictures/paa.jpg" alt="" style={{width: "100%", height:"100%", objectFit: "cover", position:"absolute", top:"0", left:"0"}}/></div>
                              	<div className="grid-item-content">
                                	<h3 style={{color:"#003165"}}>Pastor Ade Adewumi</h3>
                                    <span className="meta-data">Executive Pastor</span>
                                	<ul className="social-icons-rounded social-icons-colored">
                                        <li className="facebook"><a href="https://www.facebook.com/share/17NVrCxvpE/?mibextid=wwXIfr" target="_blank"><i className="fa fa-facebook"></i></a></li>
                                        <li className="instagram"><a href="https://www.instagram.com/ade_adewumi?igsh=MXkyajdibzl0MjJtdA==" target="_blank"><i className="fa fa-instagram"></i></a></li>
                                  	</ul>
                                	<p>Pastor In Charge of Media team.</p>
                              	</div>
                            </div>
                       	</div>
                    </div>                    
                </div>
           	</div>
         	<div className="spacer-75"></div>
             {/* <div className="lgray-bg padding-tb75" style={{opacity:1000}}> */}
           	<div className="lgray-bg padding-tb75">
            	<div className="container">
                    <div style={{textAlign: 'center', marginBottom: '10px'}}>
                        <h2 className="block-title" style={{color: '#003165'}}>Team Members</h2>
                        <p style={{color: '#666', maxWidth: '600px', margin: '0 auto'}}>The Volunteers that make up the Production team</p>
                    </div>

                    <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '16px', marginTop: '16px'}}>
                        {users.map((member, index) => (
                            <div key={index} style={{backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0', padding: '20px 12px', textAlign: 'center', width: '160px', flexShrink: 0}}>
                                {isLoggedIn ? (
                                    <a href={"/memberprofile?pid=3&mot=ia293b" + member['id'] + "&intra=yiw34"} style={{textDecoration: 'none'}}>
                                        <div style={{width: '100px', height: '100px', borderRadius: '50%', overflow: 'hidden', margin: '0 auto 10px', border: '3px solid #ffa800', cursor: 'pointer'}}>
                                            <img src={member['image']} style={{width: '100%', height: '100%', objectFit: 'cover'}} alt=""/>
                                        </div>
                                    </a>
                                ) : (
                                    <div style={{width: '100px', height: '100px', borderRadius: '50%', overflow: 'hidden', margin: '0 auto 10px', border: '3px solid #ffa800'}}>
                                        <img src={member['image']} style={{width: '100%', height: '100%', objectFit: 'cover'}} alt=""/>
                                    </div>
                                )}
                                {isLoggedIn ? (
                                    <a href={"/memberprofile?pid=3&mot=ia293b" + member['id'] + "&intra=yiw34"} style={{color: '#ffa800', fontWeight: 'bold', textDecoration: 'none', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>{member['firstname']}</a>
                                ) : (
                                    <p style={{color: '#ffa800', fontWeight: 'bold', margin: 0, fontSize: 'clamp(13px, 3.5vw, 14px)'}}>{member['firstname']}</p>
                                )}
                                <p style={{color: '#003165', fontSize: 'clamp(11px, 3vw, 12px)', margin: '4px 0 2px'}}>{member['role.name']}</p>
                                <p style={{color: '#999', fontSize: 'clamp(10px, 2.8vw, 11px)', margin: 0}}>Joined {moment(member['date_of_joining']).format('MM/YYYY')}</p>
                            </div>
                        ))}
                    </div>     


                    

                    {/* <div className="carousel-wrapper">
                        <div className="row">                                          
                            <ul className="owl-carousel carousel-fw" data-columns="6" data-autoplay="" data-pagination="no" data-arrows="yes" data-single-item="no" data-items-desktop="6" data-items-desktop-small="4" data-items-tablet="3" data-items-mobile="2">
                            {                               
                                users.map((user, index) => {  
                                    return(
                                    <li key={index} className="item">
                                    <div className="grid-item grid-staff-item grid-staff-item-compact">
                                        <div className="grid-item-inner">
                                            <div className="media-box"><a href={"/memberprofile?pid=3&mot=" + user['id']}><img src={user['image']} style={{width: "200px", height:"200px"}} alt=""/></a></div>
                                            <div className="grid-item-content">
                                             <a href={"/memberprofile?pid=3&mot=" + user['id']}>{user['firstname']}</a>
                                                <span className="meta-data">{user['role.name']}</span>
                                                <span className="meta-data">Joined: {moment(user['date_of_joining']).format('MM/YYYY')}</span>
                                            </div>
                                        </div>
                                    </div>
                                </li>)
                                 
                               })
                            }                            
                                                    
                            </ul>                                                    
                            
                        </div>
                    </div> */}
                </div>
           	</div>
            {
                isLoggedIn && loggedInUser['role.name'] === 'admin'  ? 
                <div style={{backgroundColor: "#003165"}} className="accent-bg padding-tb20 cta-fw">
                    <div className="container">
                        <a href="https://docs.google.com/spreadsheets/d/1_25kdmgYRLzpgKmOmW5ZE34Qyuggf7sjLJqDk1pydeQ/edit?usp=sharing" target="_blank" className="btn btn-default btn-ghost btn-light btn-rounded pull-right">Team Skills</a>
                        <h4>Knowledge Base within the Team</h4>
                    </div>
                </div>:<></>
            }   
            <div className="spacer-50"></div>
            {/* <div className="text-align-center">
                <h2>Join us now to make your impact</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla convallis egestas rhoncus<br/>Donec facilisis fermentum sem, ac viverra ante luctus vel. Donec vel mauris quam.</p>
                <a href="#" className="btn btn-primary btn-lg">Join us today</a>
            </div> */}
        </div>
    </div>

            <Footer/>
        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };
    
};

export default connect(mapStateToProps)(About);